// extracted by mini-css-extract-plugin
export var container = "lcSearch-module--container--e7802";
export var icon = "lcSearch-module--icon--7c763";
export var searchInput = "lcSearch-module--searchInput--8f04f";